import { render, staticRenderFns } from "./PartnerSwitcher.vue?vue&type=template&id=5144c9cb"
import script from "./PartnerSwitcher.vue?vue&type=script&lang=js"
export * from "./PartnerSwitcher.vue?vue&type=script&lang=js"
import style0 from "../GameSwitcher/game-switcher.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports